
    var v3sWbtPlayerBrowserWarningText  = {
    
      'de': 'Ihr Browser wird nicht mehr unterstützt. Die Mindestanforderung ist:',
      'en': 'Your browser is not supported anymore. The minimum requirement is:',
      'it': 'Il tuo browser non è più supportato. Il requisito minimo è:',
      'fr': 'Votre navigateur n’est plus compatible. L’exigence minimale est :',
      'pl': 'Twoja przeglądarka nie jest obsługiwana. Minimalne wymaganie:',
      'ru': 'Ваш браузер больше не поддерживается. Минимальные требования:',
      'cs': 'Váš prohlížeč už není podporován. Minimální požadavek je:',
      'es': 'Su navegador ya no es compatible. Los requisitos mínimos son:',
      'pt': 'O seu browser deixou de ser suportado. O requisito mínimo é:',
      'sk': 'Váš prehliadač už nie je podporovaný. Minimálna požiadavka je:',
      'tr': 'Tarayıcınız artık desteklenmiyor. Asgari talep:',
      'zh': '您的浏览器无法支持。最低要求：'
    };
  